module.exports = __webpack_public_path__ + "img/creationProduction2.a71bf3a2.png";